import React from 'react';
import Logo from '../../../../assets/images/conhecta_logo_mobile.svg';

import './mobileHeader.scss';
import ProfileSection from '../ProfileSection';

export default function MobileHeader() {
    const body = document.body;

    const scrollUp = "scroll-up";
    const scrollDown = "scroll-down";
    let lastScroll = 0;    

    window.addEventListener("scroll", () => {
        const currentScroll = window.pageYOffset;
        if (currentScroll == 0) {
          body.classList.remove(scrollUp);
          return;
        }
        
        if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
          // down 
          body.classList.remove(scrollUp);
          body.classList.add(scrollDown);
        } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
          // up 
          body.classList.remove(scrollDown);
          body.classList.add(scrollUp);
        }
        lastScroll = currentScroll;
    });    

    return (
        <>
            <div className='mobile-header'>
                <div class="mobile-header-wrapper">
                    <img src={ Logo } width="31" height="41" />
                    <ProfileSection />
                </div>
            </div>
        </>
    )
}